import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e2e5b1d4")

_pushScopeId("data-v-e2e5b1d4")
const _hoisted_1 = { class: "flex flex-column admin-panel-dashboard" }
const _hoisted_2 = { class: "flex clearfix admin-panel-dashboard__row" }
const _hoisted_3 = { class: "col-7 mr3" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = {
  key: 0,
  class: "flex flex-column"
}
const _hoisted_6 = { class: "h5 flex align-center py1 package__info-wrapper" }
const _hoisted_7 = { class: "package__info mr2" }
const _hoisted_8 = { class: "h5 flex align-center py1 package__info-wrapper" }
const _hoisted_9 = { class: "package__info mr2" }
const _hoisted_10 = { class: "h5 flex align-center py1 package__info-wrapper" }
const _hoisted_11 = { class: "package__info mr2" }
const _hoisted_12 = { class: "h5 flex align-center py1 package__info-wrapper" }
const _hoisted_13 = { class: "package__info mr2" }
const _hoisted_14 = { class: "col-5" }
const _hoisted_15 = { class: "flex admin-panel-dashboard__items items-stretch" }
const _hoisted_16 = { class: "\n                flex\n                items-center\n                justify-center\n                flex-auto\n                center\n                admin-panel-dashboard__item-content\n              " }
const _hoisted_17 = { class: "\n                flex\n                items-center\n                justify-center\n                flex-auto\n                center\n                admin-panel-dashboard__item-content\n              " }
const _hoisted_18 = { class: "flex clearfix admin-panel-dashboard__row" }
const _hoisted_19 = { class: "flex flex-column flex-auto" }
const _hoisted_20 = {
  key: 0,
  class: "flex flex-auto admin-panel-dashboard__games"
}
const _hoisted_21 = { class: "flex flex-column justify-between items-center admin-panel-dashboard__game" }
const _hoisted_22 = { class: "flex items-center" }
const _hoisted_23 = {
  key: 0,
  class: "mt1 flex items-center justify-center flex-wrap"
}
const _hoisted_24 = { class: "m1" }
const _hoisted_25 = {
  key: 1,
  class: "center no-games"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_BaseBox = _resolveComponent("BaseBox")!
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_BaseBox, {
          class: "flex flex-auto",
          title: _ctx.$t('adminPanel.dashboard.yourPlan')
        }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_4, [
              (_ctx.company.package)
                ? (_openBlock(), _createBlock("div", _hoisted_5, [
                    _createVNode("div", _hoisted_6, [
                      _createVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('adminPanel.dashboard.companyId')), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.company.id), 1)
                    ]),
                    _createVNode("div", _hoisted_8, [
                      _createVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('adminPanel.dashboard.mode')), 1),
                      _createVNode("div", null, _toDisplayString(_ctx.$t('checkout.withRegister.freePackage')), 1)
                    ]),
                    _createVNode("div", _hoisted_10, [
                      _createVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('adminPanel.dashboard.boughtOn')), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.formatDate(_ctx.company.package.boughtOn)), 1)
                    ]),
                    _createVNode("div", _hoisted_12, [
                      _createVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('adminPanel.dashboard.packageExpiresOn')), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.formatDate(1646104272910)), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["title"])
      ]),
      _createVNode("div", _hoisted_14, [
        _createVNode("div", _hoisted_15, [
          _createVNode(_component_BaseBox, {
            small: "",
            title: _ctx.$t('adminPanel.dashboard.users'),
            class: "mr2 admin-panel-dashboard__item flex flex-column"
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_16, _toDisplayString(_ctx.userCount), 1)
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(_component_BaseBox, {
            small: "",
            title: _ctx.$t('adminPanel.dashboard.gamesPlayed'),
            class: "admin-panel-dashboard__item flex flex-column"
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_17, _toDisplayString(_ctx.gamesCount), 1)
            ]),
            _: 1
          }, 8, ["title"])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_18, [
      _createVNode("div", _hoisted_19, [
        (_ctx.company.package?.gamesInPackage)
          ? (_openBlock(), _createBlock("div", _hoisted_20, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.gamesSorted, ([key, value]) => {
                return (_openBlock(), _createBlock(_component_BaseBox, {
                  class: "admin-panel-dashboard__game-box flex-auto",
                  key: key
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_21, [
                      _createVNode("div", _hoisted_22, [
                        _createVNode("img", {
                          alt: `logo for ${_ctx.GAME_NAMES_HUMANIZED[key]} game`,
                          src: _ctx.imageConfig[key],
                          class: "mr1 navigation__item-image"
                        }, null, 8, ["alt", "src"]),
                        _createVNode("h3", null, _toDisplayString(_ctx.GAME_NAMES_HUMANIZED[key]), 1)
                      ]),
                      (value > 0)
                        ? (_openBlock(), _createBlock("div", _hoisted_23, [
                            _createVNode("div", _hoisted_24, [
                              _createVNode(_component_router_link, {
                                to: _ctx.createNewGameConfig[key]
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_Button, null, {
                                    default: _withId(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('newGame.startNewGame')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ]),
                            _createVNode(_component_router_link, {
                              to: _ctx.adjustGameConfig[key]
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_Button, { class: "p-button-outlined" }, {
                                  default: _withId(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('newGame.adjustGame')), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]))
                        : (_openBlock(), _createBlock("div", _hoisted_25, _toDisplayString(_ctx.$t('adminPanel.dashboard.needMoreGames')), 1))
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
})